/* eslint-disable react-hooks/exhaustive-deps */
import { mdiPlus, mdiExport, mdiFilterVariant, mdiHistory } from "@mdi/js";
import Icon from "@mdi/react";
import DrawerModal, {
  DrawerModalLoaction,
} from "../../../ui/new_components/common/drawer_modal";
import EntityHistory, {
  GetMasterLogsByEntityApi,
} from "../../purchase_order/purchase_order_create/components/entity_logs";
import {
  FunctionComponent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { useHistory } from "react-router-dom";
import LoadingWidget from "../../../context_providers/modal/loader";
import {
  useToast,
  ToastType,
} from "../../../context_providers/toast/toast_ctx";
import { urls } from "../../../utils/urls";
import {
  defaultPartyFilter,
  LegalEntityType,
  PartyFilter,
  PartyModel,
  PartyStatusMap,
  PartyType,
  taxRegType,
} from "../models/party_model";
import { useAuth } from "../../../context_providers/auth/authProvider";
import { ACTION, MODULE } from "../../../utils/enums";
import VendorSearchField from "./components/vendor_code_search_widget";
import { debounce } from "lodash";
import Pagination from "../../../ui/new_components/common/pagination";
import {
  BulkApproveVendorsRepo,
  ExportRepo,
  GetVendorRepo,
} from "./repo/parties_repo";
import { stateData } from "../../../utils/states_data";
import moment from "moment";
import FilterDropDown from "../../../ui/new_components/common/filter_drop_down";
import { fetchPost } from "../../../service/api_client";
import {
  ResponsiveListShell,
  FilterSheet,
  DateRangeFilter,
  MobileRecordCard,
  MobileRecordCardList,
  StatusBadge,
  EmptyState,
} from "../../../ui/new_components/common/responsive";

interface PartyListScreenProps {}

const PartyListScreen: FunctionComponent<PartyListScreenProps> = () => {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState<PartyModel[]>([]);
  const [isMaker, setIsMaker] = useState<boolean>(false);
  const [isChecker, setIsChecker] = useState<boolean>(false);
  const { isAuthorised } = useAuth();
  const [filter, setFilter] = useState<PartyFilter>(defaultPartyFilter);
  const [states, setStates] = useState<string[]>([]);
  const [selectedItems, setSelectedItems] = useState<PartyModel[]>([]);
  const [showFilter, setShowFilter] = useState(
    () => typeof window !== "undefined" && window.innerWidth >= 768,
  );
  const [showHistory, setShowHistory] = useState<string>();
  const venderFileInputRef = useRef<HTMLInputElement>(null);

  const fetchData = async (prop: PartyFilter) => {
    setLoading(true);
    try {
      const finalFilter = { ...prop, count: 20 };

      const res = await GetVendorRepo(finalFilter);
      if (res.success) {
        setData(res.data.result);
        if (res.data.metadata) {
          setTotal(res.data.metadata.total);
        }
      } else {
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
    }
    setLoading(false);
  };

  const bulkApprove = async () => {
    setLoading(true);
    try {
      if (selectedItems.length === 0) {
        setLoading(false);

        return showToast({
          type: ToastType.error,
          text: "Please Select a Vendor to approve",
        });
      }

      for (let i = 0; i < selectedItems.length; i++) {
        let vendor: PartyModel = selectedItems[i];
        if (
          vendor.status === PartyStatusMap["Save Draft"] ||
          vendor.status === PartyStatusMap.Approved ||
          vendor.status === PartyStatusMap.Rejected
        ) {
          return showToast({
            type: ToastType.error,
            text: "Saved Draft || Approved || Rejected Vendors cannot be approved",
          });
        }
      }

      const res = await BulkApproveVendorsRepo(selectedItems);
      if (res.success) {
        setLoading(false);
        fetchData(filter);
        if (res.failed && res.failed.length > 0) {
          showToast({
            type: ToastType.error,
            text: `Could not approve: ${res.failed
              .map((f: any) => `${f.name} (${f.id}) - ${f.error}`)
              .join("; ")}`,
          });
        }
        const approvedCount = selectedItems.length - (res.failed?.length ?? 0);
        if (approvedCount > 0) {
          showToast({
            type: ToastType.success,
            text: "Approved succesfully",
          });
        }
        return;
      } else {
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
    }
    setLoading(false);
  };

  const exportData = async () => {
    setLoading(true);
    try {
      const res = await ExportRepo(filter);

      if (!res.ok) {
        return showToast({ type: ToastType.error, text: res.statusText });
      }

      const header = res.headers.get("Content-Disposition");
      const parts = header?.split(";");
      let downloadFilename = "";
      if (parts) {
        downloadFilename = parts[1].split("=")[1];
        downloadFilename = downloadFilename.substring(
          1,
          downloadFilename.length - 1,
        );
      }
      const blob = await res.blob();

      const fileUrl = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", downloadFilename ?? `export.csv`);

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      link.parentNode?.removeChild(link);
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
    }
    setLoading(false);
  };

  useEffect(() => {
    const checker_permission_result = isAuthorised({
      module: MODULE.master_vendor_checker,
      action: ACTION.READ,
    });
    const maker_permission_result = isAuthorised({
      module: MODULE.master_vendor_maker,
      action: ACTION.CREATE,
    });
    setIsChecker(checker_permission_result);
    setIsMaker(maker_permission_result);
  }, [isAuthorised]);

  useEffect(() => {
    const allStates = stateData.map((state) => state.name);
    setStates(allStates);
  }, []);

  const debouncedHandler = useCallback(
    debounce((prop: PartyFilter) => {
      if (prop) fetchData(prop);
    }, 500),
    [],
  );

  useEffect(() => {
    debouncedHandler(filter);
  }, [page, filter, debouncedHandler]);

  const navaigation = useHistory();

  const onSelect = (d: PartyModel) => {
    if (isMaker) {
      if (
        d.status === PartyStatusMap.Approved ||
        d.status === PartyStatusMap.Rejected ||
        d.status === PartyStatusMap["Approve Pending"] ||
        d.status === PartyStatusMap["Update Pending"]
      ) {
        navaigation.push(
          urls.procurement_masters_party + "/view-details/" + d.id,
        );
      } else if (d.status === PartyStatusMap["Save Draft"]) {
        navaigation.push(urls.procurement_masters_party + "/create/" + d.id);
      } else
        navaigation.push(urls.procurement_masters_party + "/update/" + d.id);
    } else if (isChecker) {
      if (
        d.status === PartyStatusMap["Save Draft"] ||
        d.status === PartyStatusMap.Approved ||
        d.status === PartyStatusMap.Rejected
      ) {
        navaigation.push(
          urls.procurement_masters_party + "/view-details/" + d.id,
        );
      } else {
        // Navigate to approve page
        navaigation.push(
          urls.procurement_masters_party + "/approve-reject/" + d.id,
        );
      }
    }
  };

  function handleUpdate(): void {
    if (selectedItems.length > 1) {
      showToast({
        type: ToastType.error,
        text: "Please select one item to edit",
      });
    } else if (selectedItems.length === 0) {
      showToast({
        type: ToastType.error,
        text: "Please select an item to edit",
      });
    } else {
      if (selectedItems[0]?.status === PartyStatusMap["Save Draft"]) {
        navaigation.push(
          urls.procurement_masters_party + "/create/" + selectedItems[0]!.id,
        );
      } else {
        navaigation.push(
          urls.procurement_masters_party + "/update/" + selectedItems[0]!.id,
        );
      }
    }
  }

  const handleUploadVenderClick = () => {
    if (venderFileInputRef.current) {
      venderFileInputRef.current.click();
    }
  };

  const handleDownloadTemplate = () => {
    const headers = [
      "Vendor Name",
      "Vendor Type",
      "Contact No",
      "Email ID",
      "Website",
      "Mobile No. of contact person",
      "Name of Contact Person",
      "Designation",
      "Email ID of Contact Person",
      "Contact Detail of CEO/Director",
      "Name of CEO/Director",
      "Email ID of CEO/Director",
      "Name of Accounts SPOC",
      "Mobile No. of Accounts SPOC",
      "Email ID of Accounts SPOC",
      "Address Type",
      "Registered Office Address",
      "Line2",
      "Line3",
      "Country",
      "State",
      "City",
      "Postal Code",
      "MSME Registration",
      "MSME Category",
      "MSME Registration number",
      "Account holder name",
      "Account no.",
      "Bank Name",
      "Bank Address",
      "Bank Branch",
      "Swift code/IFSC Code",
      "MICR Code",
      "GST Registration Type",
      "GST Nos.",
      "PAN",
      "Legal Entity",
      "ADHAAR Number",
      "CIN/LLPIN Number",
      "Date of Commencement of Business",
    ];

    const csvContent = [headers]
      .map((e) => e.map((v) => `"${v}"`).join(","))
      .join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "party_template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleUploadCSV = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const validMimeTypes = ["text/csv", "application/vnd.ms-excel"];
    const fileExtension = file.name.split(".").pop()?.toLowerCase();

    if (!validMimeTypes.includes(file.type) && fileExtension !== "csv") {
      showToast({ type: ToastType.error, text: "Only CSV files are allowed." });
      return;
    }

    console.log(file);

    const formData = new FormData();
    formData.append("file", file);

    const upload_url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/accounts/party/upload-csv`;

    try {
      const res = await fetchPost(upload_url, formData);

      if (res.success) {
        showToast({ type: ToastType.success, text: res.message });
      } else {
        showToast({
          type: ToastType.error,
          text: res.error || "Upload failed.",
        });
      }
    } catch (err) {
      showToast({
        type: ToastType.error,
        text: "File upload failed. " + err,
      });
    }
  };

  return (
    <>
      {showHistory && (
        <DrawerModal
          location={DrawerModalLoaction.right}
          show={showHistory !== undefined}
          onClose={() => setShowHistory(undefined)}
          title="Vendor History"
        >
          <EntityHistory
            fetchLogs={({ page, count }) =>
              GetMasterLogsByEntityApi({
                entityType: "vendor",
                entityId: showHistory,
                page,
                count,
              })
            }
          />
        </DrawerModal>
      )}
      <ResponsiveListShell
        title="Vendor"
        count={total}
        onRefresh={() => fetchData(filter)}
        search={
          <div id="vendor_code_filter">
            <VendorSearchField
              placeholder="Vendor Code"
              defaulValue={filter.id ?? ""}
              onClear={() => setFilter((prevData) => ({ ...prevData, id: "" }))}
              onSubmit={(value: string) =>
                setFilter((prevData) => ({ ...prevData, id: value }))
              }
            />
          </div>
        }
        actions={
          <>
            {isMaker && (
              <>
                <button
                  id="create_vendor_button"
                  onClick={() => {
                    navaigation.push(
                      urls.procurement_masters_party + "/create",
                    );
                  }}
                  className="flex gap-1 items-center cursor-pointer rounded p-1 bg-myPrimaryColor hover:scale-105 duration-200 text-white transform text-xs"
                >
                  <Icon path={mdiPlus} className="h-4 w-4"></Icon>Create
                </button>
                <button
                  id="update_vendor_button"
                  onClick={handleUpdate}
                  className="flex gap-1 items-center cursor-pointer rounded p-1 bg-myPrimaryColor hover:scale-105 duration-200 text-white transform text-xs"
                >
                  <Icon path={mdiPlus} className="h-4 w-4"></Icon>Update
                </button>

                <label
                  id="download_template_button"
                  onClick={handleDownloadTemplate}
                  title="Download vendor upload template"
                  className="flex gap-1 items-center cursor-pointer rounded p-1 bg-myPrimaryColor text-white hover:scale-105 duration-200 text-xs"
                >
                  Download Template
                </label>
                <input
                  id="vendor_csv_file_input"
                  type="file"
                  ref={venderFileInputRef}
                  accept=".csv"
                  onChange={handleUploadCSV}
                  className="hidden"
                />
                <button
                  id="upload_vendors_button"
                  onClick={handleUploadVenderClick}
                  className="flex gap-1 items-center cursor-pointer rounded p-1 bg-myPrimaryColor text-white hover:scale-105 duration-200 text-xs"
                >
                  Upload Vendors
                </button>
              </>
            )}

            {isChecker && (
              <button
                id="bulk_approve_button"
                onClick={bulkApprove}
                className="flex gap-1 items-center rounded p-1 bg-myPrimaryColor text-white hover:scale-105 duration-200 text-xs"
              >
                <Icon path={mdiExport} className="h-4 w-4" />
                Bulk Approve
              </button>
            )}

            <button
              id="export_button"
              onClick={exportData}
              className="flex gap-1 items-center rounded p-1 bg-myPrimaryColor text-white hover:scale-105 duration-200 text-xs"
            >
              <Icon path={mdiExport} className="h-4 w-4" />
              Export
            </button>
          </>
        }
        filterToggle={
          <div className="flex gap-2 items-center">
            <h6 className="font-normal text-xs">Filters</h6>
            <div
              id="toggle_filters_button"
              onClick={() => setShowFilter((v) => !v)}
              className="flex items-center justify-center bg-gray-200 p-1 rounded-full hover:bg-gray-800 hover:text-white cursor-pointer"
            >
              <Icon path={mdiFilterVariant} className="w-4 h-4" />
            </div>
          </div>
        }
      >
        <FilterSheet
          show={showFilter}
          onClose={() => setShowFilter(false)}
          onApply={() => setShowFilter(false)}
          onReset={() => setFilter(defaultPartyFilter)}
          gridClassName="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-3 gap-y-2 items-start"
        >
          <div id="vendor_created_at_filter">
            <label>Created At</label>
            <DateRangeFilter
              compact
              showChips={false}
              fromDate={
                filter.from_date
                  ? moment(filter.from_date).format("YYYY-MM-DD")
                  : ""
              }
              toDate={
                filter.to_date
                  ? moment(filter?.to_date).format("YYYY-MM-DD")
                  : ""
              }
              onFromChange={(v) =>
                setFilter({
                  ...filter,
                  from_date: v
                    ? new Date(new Date(v).setHours(0, 0, 0, 0))
                    : undefined,
                })
              }
              onToChange={(v) =>
                setFilter({
                  ...filter,
                  to_date: v
                    ? new Date(new Date(v).setHours(23, 59, 59, 999))
                    : undefined,
                })
              }
            />
          </div>
          <div>
            <label htmlFor="app_status">Vendor Name</label>
            <VendorSearchField
              id="vendor_name_filter"
              defaulValue={filter.name ?? ""}
              onClear={() =>
                setFilter((prevData) => ({ ...prevData, name: "" }))
              }
              onSubmit={(value: string) =>
                setFilter((prevData) => ({ ...prevData, name: value }))
              }
            />
          </div>
          <div>
            <label htmlFor="item_type">Legal Entity</label>
            <FilterDropDown
              placeholder="legal_entity_type"
              onClearAll={() =>
                setFilter({
                  ...filter,
                  legal_entity_type: undefined,
                  page: 1,
                  count: 20,
                })
              }
              onDelete={(type) => {
                setFilter({
                  ...filter,
                  legal_entity_type: filter?.legal_entity_type?.filter(
                    (f: any) => f !== type,
                  ),
                });
              }}
              onSelect={(type) => {
                setFilter((old) => ({
                  ...old,
                  legal_entity_type: [...(old?.legal_entity_type ?? []), type],
                }));
              }}
              selectedOptions={filter?.legal_entity_type ?? []}
              options={Object.values(LegalEntityType).map((t) => ({
                label: t,
                value: t,
              }))}
            />
          </div>
          <div>
            <label htmlFor="item_type">Vendor Type</label>
            <FilterDropDown
              placeholder="item_type"
              onClearAll={() => setFilter({ ...filter, type: undefined })}
              onDelete={(type) => {
                setFilter({
                  ...filter,
                  type: filter?.type?.filter((f: any) => f !== type),
                  page: 1,
                  count: 20,
                });
              }}
              onSelect={(type) => {
                setFilter((old) => ({
                  ...old,
                  type: [...(old?.type ?? []), type],
                }));
              }}
              selectedOptions={filter?.type ?? []}
              options={Object.values(PartyType).map((t) => ({
                label: t,
                value: t,
              }))}
            />
          </div>
          <div>
            <label htmlFor="item_type">GST Reg Type</label>
            <FilterDropDown
              placeholder="reg_type"
              onClearAll={() =>
                setFilter({
                  ...filter,
                  reg_type: undefined,
                  page: 1,
                  count: 20,
                })
              }
              onDelete={(type) => {
                setFilter({
                  ...filter,
                  reg_type: filter?.reg_type?.filter((f: any) => f !== type),
                });
              }}
              onSelect={(type) => {
                setFilter((old) => ({
                  ...old,
                  reg_type: [...(old?.reg_type ?? []), type],
                }));
              }}
              selectedOptions={filter?.reg_type ?? []}
              options={Object.values(taxRegType).map((t) => ({
                label: t,
                value: t,
              }))}
            />
          </div>
          <div>
            <label htmlFor="sub_category">State</label>
            <FilterDropDown
              placeholder="state"
              onClearAll={() => setFilter({ ...filter, state: undefined })}
              onDelete={(type) => {
                setFilter({
                  ...filter,
                  state: filter?.state?.filter((f: any) => f !== type),
                  page: 1,
                  count: 20,
                });
              }}
              onSelect={(type) => {
                setFilter((old) => ({
                  ...old,
                  state: [...(old?.state ?? []), type],
                }));
              }}
              selectedOptions={filter?.state ?? []}
              options={Object.values(states).map((t) => ({
                label: t,
                value: t,
              }))}
            />
          </div>
          <div>
            <label htmlFor="app_status">City</label>
            <VendorSearchField
              id="city_filter"
              defaulValue={filter.city ?? ""}
              onClear={() =>
                setFilter((prevData) => ({ ...prevData, city: "" }))
              }
              onSubmit={(value: string) =>
                setFilter((prevData) => ({ ...prevData, city: value }))
              }
            />
          </div>
          <div>
            <label htmlFor="app_status">Approval Status</label>
            <FilterDropDown
              placeholder="status"
              onClearAll={() => setFilter({ ...filter, status: undefined })}
              onDelete={(type) => {
                setFilter({
                  ...filter,
                  status: filter?.status?.filter((f: any) => f !== type),
                  page: 1,
                  count: 20,
                });
              }}
              onSelect={(type) => {
                setFilter((old) => ({
                  ...old,
                  status: [...(old?.status ?? []), type],
                }));
              }}
              selectedOptions={filter?.status ?? []}
              options={Object.values(PartyStatusMap).map((t) => ({
                label: t,
                value: t,
              }))}
            />
          </div>
          <div>
            <label htmlFor="gst_no">GST No</label>
            <input
              id="gst_no"
              placeholder=""
              value={filter.gst_no || ""}
              className="border rounded text-sm w-full h-8 focus:outline-none"
              onChange={(e) =>
                setFilter((prev) => ({
                  ...prev,
                  gst_no: e.target.value,
                }))
              }
              type="text"
            />
          </div>
          <div>
            <label htmlFor="pan">PAN</label>
            <input
              id="pan"
              placeholder=""
              value={filter.pan || ""}
              className="border rounded text-sm w-full h-8 focus:outline-none"
              onChange={(e) =>
                setFilter((prev) => ({
                  ...prev,
                  pan: e.target.value,
                }))
              }
              type="text"
            />
          </div>
          <div>
            <label htmlFor="app_status">Phone Number</label>
            <input
              id="phone_number"
              placeholder=""
              value={filter.phone_number || ""}
              className="border rounded text-sm w-full h-8 focus:outline-none"
              onChange={(e) =>
                setFilter((prev) => ({
                  ...prev,
                  phone_number: e.target.value,
                }))
              }
              type="text"
            />
          </div>
        </FilterSheet>

        {data.length > 0 ? (
          <>
            <div className="hidden md:block my-2 border">
              <div className="overflow-auto">
                <table
                  id="vendor_list_table"
                  className="w-full text-xs divide-y divide-gray-200 relative"
                >
                  <thead className="text-xs py-2 bg-white z-10">
                    <tr className="border">
                      <th>
                        <div className="">
                          <input
                            type="checkbox"
                            name=""
                            id=""
                            checked={
                              selectedItems?.length === data?.length
                                ? true
                                : false
                            }
                            disabled={isChecker && !isMaker ? false : true}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedItems([...data]);
                              } else {
                                setSelectedItems([]);
                              }
                            }}
                          />
                        </div>
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-center">
                        History
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Vendor Code
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Vendor Name
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Created At
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Type
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Mobile No.
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Legal Entity
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        MSME Registration
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        GST Reg type
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        GST No
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        PAN
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        City
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        State
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Status
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Designation of Accounts SPOC
                      </th>
                    </tr>
                  </thead>
                  <tbody className="">
                    {data.map((item, i) => {
                      const isSelected = selectedItems.includes(item);
                      return (
                        <tr
                          id={`vendor_row_${item.id}`}
                          className="border text-center "
                          key={i}
                        >
                          <td>
                            <div className="p-2">
                              <input
                                type="checkbox"
                                name=""
                                id=""
                                checked={isSelected}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelectedItems((prev) => [...prev, item]);
                                  } else {
                                    setSelectedItems((prev) =>
                                      prev.filter(
                                        (selectedItem) => selectedItem !== item,
                                      ),
                                    );
                                  }
                                }}
                              />
                            </div>
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-center">
                            <div
                              id={`vendor_history_${item.id}`}
                              className="cursor-pointer flex justify-center"
                              title="History"
                              onClick={() => setShowHistory(item.id)}
                            >
                              <Icon path={mdiHistory} size="16"></Icon>
                            </div>
                          </td>
                          <td
                            id={`vendor_link_${item.id}`}
                            className="px-3 py-3 whitespace-nowrap text-left cursor-pointer text-blue-600 hover:underline"
                            role="button"
                            onClick={() => onSelect(item)}
                          >
                            {item.id}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-left">
                            {item.name}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-left">
                            {moment(item.created_at).format("DD-MM-YYYY")}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap  text-left">
                            {item.type ?? "--"}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-left">
                            {item.mail_detail?.contact_mobile}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-left">
                            {item.legal_entity_type}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-left">
                            {item.msme_registration?.msme_registration_number}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-left">
                            {item.tax_detail.reg_type ?? "--"}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-left">
                            {item.tax_detail.gst_no[0] ?? "--"}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-left">
                            {item.tax_detail.pan ?? "--"}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-left">
                            {item.mail_detail.address.city ?? "--"}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-left">
                            {item.mail_detail.address.state ?? "--"}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-left">
                            <StatusBadge status={item.status} kind="generic" />
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-center">
                            {item?.mail_detail?.designation ?? "--"}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            <MobileRecordCardList>
              <label className="flex items-center gap-2 text-xs text-gray-600">
                <input
                  id="vendor_select_all_mobile"
                  type="checkbox"
                  checked={
                    selectedItems?.length === data?.length ? true : false
                  }
                  disabled={isChecker && !isMaker ? false : true}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedItems([...data]);
                    } else {
                      setSelectedItems([]);
                    }
                  }}
                />
                Select all
                {selectedItems.length > 0 && (
                  <span className="text-gray-400">
                    ({selectedItems.length} selected)
                  </span>
                )}
              </label>
              {data.map((item, i) => (
                <MobileRecordCard
                  id={`vendor_row_mobile_${item.id}`}
                  key={i}
                  onClick={() => onSelect(item)}
                  leading={
                    <input
                      id={`vendor_select_mobile_${item.id}`}
                      type="checkbox"
                      className="h-4 w-4 mt-0.5"
                      checked={selectedItems.includes(item)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedItems((prev) => [...prev, item]);
                        } else {
                          setSelectedItems((prev) =>
                            prev.filter(
                              (selectedItem) => selectedItem !== item,
                            ),
                          );
                        }
                      }}
                    />
                  }
                  title={item.id}
                  status={<StatusBadge status={item.status} kind="generic" />}
                  fields={[
                    { label: "Name", value: item.name },
                    {
                      label: "Created At",
                      value: moment(item.created_at).format("DD-MM-YYYY"),
                    },
                    { label: "Type", value: item.type ?? "-" },
                    {
                      label: "Mobile",
                      value: item.mail_detail?.contact_mobile ?? "-",
                    },
                    {
                      label: "Legal Entity",
                      value: item.legal_entity_type ?? "-",
                    },
                    {
                      label: "MSME Registration",
                      value:
                        item.msme_registration?.msme_registration_number ?? "-",
                    },
                    {
                      label: "GST Reg Type",
                      value: item.tax_detail.reg_type ?? "-",
                    },
                    {
                      label: "GST No",
                      value: item.tax_detail.gst_no[0] ?? "-",
                    },
                    { label: "PAN", value: item.tax_detail.pan ?? "-" },
                    {
                      label: "City",
                      value: item.mail_detail.address.city ?? "-",
                    },
                    {
                      label: "State",
                      value: item.mail_detail.address.state ?? "-",
                    },
                    {
                      label: "Accounts SPOC Designation",
                      value: item?.mail_detail?.designation ?? "-",
                    },
                  ]}
                  actions={[
                    {
                      icon: mdiHistory,
                      title: "History",
                      onClick: () => setShowHistory(item.id),
                    },
                  ]}
                />
              ))}
            </MobileRecordCardList>

            <div
              id="vendor_list_pagination"
              className="mt-3 sticky bottom-0 bg-white z-10 border-t flex justify-between items-center px-4 py-2"
            >
              <Pagination
                itemCount={filter.count}
                page={filter.page}
                total={total}
                count={filter.count}
                onChange={(page) => setFilter((o) => ({ ...o, page }))}
              />
            </div>
          </>
        ) : !loading ? (
          <EmptyState
            title="No Vendors found!"
            message="Try adjusting your search or filters."
            imageSrc="/images/nodata.png"
          />
        ) : null}
      </ResponsiveListShell>

      {loading && <LoadingWidget></LoadingWidget>}
    </>
  );
};

export default PartyListScreen;
